export const LabelsText = {
    "www": {
        "enter_the_lucky_draw": "Enter the lucky draw to win Amazon voucher by answering the question correctly",
        "chance_to_win": "CHANCE TO WIN",
        "ready_to_start": "Ready to get started",
        "sign_up_start": "Sign up and start answering the question. (Gift card will be sent to this Google mail ID)",
        "share_with_frds": "Share with your friends",
        "ready_to_play": "Ready to Play",
        "watch_video": "Watch the video and answer the question",
        "sorry_wrong_ans": "Sorry, wrong answer! Thanks for participating",
        "congrats_text": "Congratulations, that's right \"You have qualified for the lucky draw\"",
        "winner_text": "Winners will receive Rs.500 Amazon gift card from Oneindia on their registered e-mail address.",
        "check_winner_on": "Check winner on DATE ",
    },
    "hindi": {
        "enter_the_lucky_draw": "Enter the lucky draw to win Amazon voucher by answering the question correctly",
        "chance_to_win": "CHANCE TO WIN",
        "ready_to_start": "Ready to get started",
        "sign_up_start": "Sign up and start answering the question. (Gift card will be sent to this Google mail ID)",
        "share_with_frds": "Share with your friends",
        "ready_to_play": "Ready to Play",
        "watch_video": "Watch the video and answer the question",
        "sorry_wrong_ans": "Sorry, wrong answer! Thanks for participating",
        "congrats_text": "Congratulations, that's right \"You have qualified for the lucky draw\"",
        "winner_text": "Winners will receive Rs.500 Amazon gift card from Oneindia on their registered e-mail address.",
        "check_winner_on": "Check winner on DATE ",
    },
    "tamil": {
        "enter_the_lucky_draw": "கேள்விகளுக்கு சரியான பதில்களை அளித்து அமேசான் கூப்பன் வெல்லும் வாய்ப்பை பெறுங்கள்",
        "chance_to_win": "வெற்றிபெற வாய்ப்பு",
        "ready_to_start": "என்ன ஆரம்பிக்கலாமா",
        "sign_up_start": "சைன் அப் செய்து பதில்களை அளியுங்கள்.(கிப்ட் கார்ட் உங்கள் கூகுள் மெயில் ஐடிக்கு அனுப்பப்படும்)",
        "share_with_frds": "உங்கள் நண்பர்களுடன் ஷேர் செய்யுங்கள்",
        "ready_to_play": "விளையாட ரெடியா",
        "watch_video": "வீடியோவை பாருங்கள் கேள்விக்கு பதில் சொல்லுங்கள்! ",
        "sorry_wrong_ans": "மன்னிக்கவும், தவறான பதில்! போட்டியில் கலந்து கொண்டதற்கு நன்றி",
        "congrats_text": "வாவ், உங்களின் பதில் சரி \"கூப்பன் வெல்லும் குலுக்கள் வாய்ப்பை பெற்றுள்ளீர்கள்\"",
        "winner_text": "ரூ.500 மதிப்பிலான அமேசான் கூப்பன் #OneindiaDW மூலம் வெற்றியாளர்களின் ரிஜிஸ்டர் செய்யப்பட்ட மெயில் ஐடிக்கு அனுப்பப்படும்",
        "check_winner_on": "வெற்றியாளரை DATE அன்று தெரிந்து கொள்ளுங்கள். ",
    },
    "telugu": {
        "enter_the_lucky_draw": "అమెజాన్ వోచర్ గెలిచేందుకు ఇచ్చిన ప్రశ్నకు సరైన సమాధానం చెప్పి లక్కీ డ్రాకు అర్హత పొందండి",
        "chance_to_win": "గెలిచేందుకు అవకాశం",
        "ready_to_start": "సిద్ధంగా ఉన్నారా",
        "sign_up_start": "సైన్ అప్ అయి ప్రశ్నలకు సమాధానం ఇవ్వండి.( ఈ గూగుల్ మెయిల్ ఐడీకి  గిఫ్ట్ కార్డు పంపబడుతుంది)",
        "share_with_frds": "మీ స్నేహితులకు షేర్ చేయండి",
        "ready_to_play": "ఆడేందుకు సిద్ధంగా ఉన్నారా",
        "watch_video": "వీడియోను చూసి అడిగే ప్రశ్నకు సమాధానం ఇవ్వండి ",
        "sorry_wrong_ans": "క్షమించండి, మీరిచిన్న సమాధానం తప్పు. పాల్గొన్నందుకు ధన్యవాదాలు",
        "congrats_text": "కంగ్రాట్స్, ఇది సరైన సమాధానం\"మీరు లక్కీ డ్రాకు అర్హత సాధించారు\"",
        "winner_text": "విజేతలు రూ.500 విలువ చేసే అమెజాన్ గిఫ్ట్‌ కార్డును #OneindiaDW నుంచి రిజిస్టర్ మెయిల్ ఐడీలకు పంపబడుతుంది",
        "check_winner_on": "DATEన విజేతలు ఎవరనేది చెక్ చేసుకోండి",
    },
    "kannada": {
        "enter_the_lucky_draw": "ಪ್ರಶ್ನೆಗೆ ಸರಿಯಾಗಿ ಉತ್ತರಿಸಿ ಲಕ್ಕಿ ಡ್ರಾ ಮೂಲಕ ಅಮೆಜಾನ್ ವೋಚರ್ ಗೆದ್ದುಕೊಳ್ಳಿರಿ ",
        "chance_to_win": "ಗೆಲ್ಲಲು ಅವಕಾಶ",
        "ready_to_start": "ಪ್ರಾರಂಭಿಸಲು ತಯಾರಿದ್ದೀರಾ",
        "sign_up_start": "ಸೈನ್ ಅಪ್ ಆಗಿ ಪ್ರಶ್ನೆಗೆ ಉತ್ತರಿಸಲು ಪ್ರಾರಂಭಿಸಿ. (ಈ ಗೂಗಲ್ ಮೇಲ್ ಐಡಿಗೆ ಗಿಫ್ಟ್ ಕಾರ್ಡ್ ಅನ್ನು ಕಳುಹಿಸಲಾಗುತ್ತದೆ)",
        "share_with_frds": "ನಿಮ್ಮ ಸ್ನೇಹಿತರೊಂದಿಗೆ ಹಂಚಿಕೊಳ್ಳಿ",
        "ready_to_play": "ಆಟವಾಡಲು ಸಿದ್ಧರಾಗಿ",
        "watch_video": "ವಿಡಿಯೋ ನೋಡಿ ಹಾಗೂ ಪ್ರಶ್ನೆಗೆ ಉತ್ತರಿಸಿ",
        "sorry_wrong_ans": "ಕ್ಷಮಿಸಿ ನಿಮ್ಮ ಉತ್ತರ ತಪ್ಪಾಗಿದೆ! ಭಾಗವಹಿಸಿದ್ದಕ್ಕಾಗಿ ಧನ್ಯವಾದಗಳು",
        "congrats_text": "ಅಭಿನಂದನೆಗಳು, ನಿಮ್ಮ ಉತ್ತರ ಸರಿಯಾಗಿದ್ದು, \"ನೀವು ಗೆಲ್ಲಲು ಲಕ್ಕಿ ಡ್ರಾ ಹಂತ ಪ್ರವೇಶಿಸಿದ್ದೀರಿ\"",
        "winner_text": "ವಿಜೇತರು ತಮ್ಮ ನೋಂದಣಿ ಮೇಲ್ ಐಡಿಗಳಲ್ಲಿ #OneindiaDW ನಿಂದ ರೂ 500 ಅಮೆಜಾನ್ ಗಿಫ್ಟ್ ಕಾರ್ಡ್ ಅನ್ನು ಪಡೆಯುತ್ತಾರೆ ",
        "check_winner_on": "DATE ರಂದು ವಿಜೇತರನ್ನು ಪರಿಶೀಲಿಸಿ ",
    },
    "malayalam": {
        "enter_the_lucky_draw": "ശരിയുത്തരം നല്‍കൂ, ആമസോണ്‍ വൗച്ചര്‍ സമ്മാനം ലഭിക്കുന്ന ലക്കി ഡ്രോയില്‍ പങ്കെടുക്കൂ",
        "chance_to_win": "വിജയിക്കാൻ ഇതാണ് അവസരം",
        "ready_to_start": "റെഡിയാണോ തുടങ്ങാം",
        "sign_up_start": "സൈൻ അപ് ചെയ്ത് ശരിയുത്തരങ്ങൾ തിരഞ്ഞെടുക്കൂ( ഈ മെയിൽ ഐഡിയിലേക്കാണ് ഗിഫ്റ്റ് കാർഡ് എത്തുക)",
        "share_with_frds": "സുഹൃത്തുക്കളുമായി പങ്കുവെയ്ക്കൂ",
        "ready_to_play": "മത്സരത്തിന് തയ്യാർ",
        "watch_video": "Watch the video and answer the question",
        "sorry_wrong_ans": "ക്ഷമിക്കൂ, ഉത്തരം തെറ്റാണ്. പങ്കെടുത്തതിന് നന്ദി",
        "congrats_text": "അഭിനന്ദനങ്ങൾ, ഉത്തരം ശരിയാണ്. നിങ്ങൾക്ക് ലക്കി ഡ്രോയില്‍ പങ്കെടുക്കാം",
        "winner_text": "വിജയിക്ക് ലഭിക്കുക #OneindiaDW നൽകുന്ന 500 രൂപയുടെ  ആമസോണ്‍ വൗച്ചര്‍ ",
        "check_winner_on": "വിജയി ആരെന്ന് അറിയാൻ DATE വരെ കാത്തിരിക്കൂ",
    },
}